import BaseService from './BaseService'

class CommunicationService extends BaseService {
    constructor() {
        super('/api/communications')
    }

    // List messages for a contribution
    async getByContributionId(contributionId, params = {}) {
        try {
            return await this.makeApiCall(
                'GET', 
                `${this.baseURL}/${contributionId}`,
                null,
                params
            )
        } catch (error) {
            return {
                success: false,
                message: error.message || 'Failed to fetch messages'
            }
        }
    }

    // Get single message
    async getMessageById(messageId) {
        try {
            return await this.makeApiCall(
                'GET', 
                `${this.baseURL}/message/${messageId}`
            )
        } catch (error) {
            return {
                success: false,
                message: error.message || 'Failed to fetch message'
            }
        }
    }

    // Post message (text and/or files)
    async createMessage(contributionId, formData) {
        try {
            return await this.makeApiCall(
                'POST', 
                `${this.baseURL}/${contributionId}`,
                formData,
                null,
                'multipart'
            )
        } catch (error) {
            return {
                success: false,
                message: error.message || 'Failed to send message'
            }
        }
    }

    // Update message (sender or admin)
    async updateMessage(messageId, formData) {
        try {
            return await this.makeApiCall(
                'PATCH', 
                `${this.baseURL}/${messageId}`,
                formData,
                null,
                'multipart'
            )
        } catch (error) {
            return {
                success: false,
                message: error.message || 'Failed to update message'
            }
        }
    }

    // Change message status (admin only)
    async updateMessageStatus(messageId, status) {
        try {
            return await this.makeApiCall(
                'PUT', 
                `${this.baseURL}/status/${messageId}`,
                { status }
            )
        } catch (error) {
            return {
                success: false,
                message: error.message || 'Failed to update message status'
            }
        }
    }

    // Delete message (sender or admin)
    async deleteMessage(messageId) {
        try {
            return await this.makeApiCall(
                'DELETE', 
                `${this.baseURL}/${messageId}`
            )
        } catch (error) {
            return {
                success: false,
                message: error.message || 'Failed to delete message'
            }
        }
    }

    // Download attachment
    async downloadAttachment(messageId, filename) {
        try {
            const response = await this.makeApiCall(
                'GET', 
                `${this.baseURL}/download/${messageId}/${filename}`,
                null,
                null,
                'blob'
            )
            
            if (response.success && response.data) {
                // Create a blob URL and trigger download
                const url = window.URL.createObjectURL(response.data)
                const link = document.createElement('a')
                link.href = url
                link.download = filename
                link.click()
                window.URL.revokeObjectURL(url)
            }
            
            return response
        } catch (error) {
            return {
                success: false,
                message: error.message || 'Failed to download attachment'
            }
        }
    }
}

const communicationService = new CommunicationService()
export default communicationService